import { getContent, refreshContent } from "./components/utils/api";
import { getCMSCache, setCMSCache } from "./components/utils/cmsStorage";

export async function bootstrapCMS() {
    let serverUpdatedAt = null;

    try {
        const refreshRes = await refreshContent();
        serverUpdatedAt = refreshRes?.lastUpdated;
    } catch {
        const cache = getCMSCache();
        if (cache?.data) {
            return { source: "cache-fallback", data: cache.data };
        }
        throw new Error("CMS unavailable and no cache");
    }

    const cache = getCMSCache();

    if (cache?.lastUpdated === serverUpdatedAt) {
        return { source: "cache", data: cache.data };
    }

    try {
        const contentRes = await getContent();
        setCMSCache(serverUpdatedAt, contentRes.data);
        return { source: "network", data: contentRes.data };
    } catch {
        if (cache?.data) {
            return { source: "cache-stale", data: cache.data };
        }
        throw new Error("CMS fetch failed and no cache");
    }
}
